import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import useApi from "$src/core/hooks/use-api";
import { queryKey as profilesQueryKey } from "$src/core/queries/use-profiles-query";

const MUTATION_KEY = ["profile-delete"];

type Variables = {
  id: string;
};

const useDeleteProfileMutation = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();

  const mutationFn = useCallback(
    ({ id }: Variables): Promise<void> => api.deleteProfile(id),
    [api],
  );

  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: profilesQueryKey() });
    },
  });
};

export default useDeleteProfileMutation;
